"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactTableColumnsDropdown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var reactstrap_1 = require("reactstrap");
var ReactTableColumnsDropdown = function (_a) {
    var columns = _a.columns, visibleColumns = _a.visibleColumns, setVisibleColumns = _a.setVisibleColumns, _b = _a.maxColumns, maxColumns = _b === void 0 ? 3 : _b, handleCheckboxChange = _a.handleCheckboxChange;
    var checkboxChange = function (accessorKey, header) {
        var index = visibleColumns.findIndex(function (e) { return e.header === header; });
        if (index === -1 && visibleColumns.length < maxColumns) {
            var updatedColumns = __spreadArray(__spreadArray([], visibleColumns, true), [{ accessorKey: accessorKey, header: header }], false).sort(function (a, b) {
                return columns.findIndex(function (c) { return c.header === a.header; }) -
                    columns.findIndex(function (c) { return c.header === b.header; });
            });
            setVisibleColumns(updatedColumns);
        }
        else {
            setVisibleColumns(visibleColumns.filter(function (column) { return column.header !== header; }));
        }
    };
    checkboxChange = handleCheckboxChange || checkboxChange;
    return ((0, jsx_runtime_1.jsxs)(reactstrap_1.UncontrolledButtonDropdown, __assign({ size: "xs" }, { children: [(0, jsx_runtime_1.jsx)(reactstrap_1.DropdownToggle, __assign({ color: "darker-tertiary", caret: true }, { children: "Configure columns" })), (0, jsx_runtime_1.jsx)(reactstrap_1.DropdownMenu, __assign({ end: true }, { children: columns.map(function (column) {
                    var checked = visibleColumns.some(function (visibleCol) { return visibleCol.header === column.header; });
                    return ((0, jsx_runtime_1.jsxs)(reactstrap_1.FormGroup, __assign({ check: true, className: "x5-ps-7 x5-pe-3 py-3 mb-0" }, { children: [(0, jsx_runtime_1.jsx)(reactstrap_1.Input, { disabled: (visibleColumns.length === maxColumns && !checked) ||
                                    (visibleColumns.length <= 1 && checked), checked: checked, id: column.header, type: "checkbox", onChange: function () { return checkboxChange(column.accessorKey, column.header); } }), (0, jsx_runtime_1.jsx)(reactstrap_1.Label, __assign({ check: true, for: column.header }, { children: column.header }))] }), column.header));
                }) }))] })));
};
exports.ReactTableColumnsDropdown = ReactTableColumnsDropdown;
